export default __webpack_public_path__ + "static/media/CNo.72-5.b1050cbd.jpg";